export enum EEnvironnement {
    PROD    = 0,
    STAGE   = 1,
    DEV     = 2,
    LOCAL   = 3
}